import { initializeComponents } from "~/utils/bundle_utils";
import SessionTimeoutModule from './store';
import ForcedLogoutDialog from './components/st_forced_logout_dialog';
import InactivityTimeoutDialog from './components/st_inactivity_timeout_dialog.vue';
import SessionLogoutTimer from './components/st_logout_timer';
import store from '~/base_store';

$(() => {
    store.registerModule('sessionTimeout', SessionTimeoutModule);

    initializeComponents('#vue-session-inactivity-dialog', InactivityTimeoutDialog);

    initializeComponents('#vue-session-forced-logout-dialog', ForcedLogoutDialog);
    initializeComponents('#vue-session-logout-timer', SessionLogoutTimer);
});
